import { useLang } from "@/i18n";
import LegalDoc from "./LegalDoc";

export default function Terms() {
  const { t } = useLang();
  return <LegalDoc doc={t.terms} prefix="terms" />;
}
